// ---------------------------------------------------------------------------
// PWA Caisse Tablette — Payment badge (shows type + amount + remove)
// ---------------------------------------------------------------------------

import type { Payment } from '@/lib/types';
import { formatPrice } from '@/lib/price-formatter';

interface PaymentBadgeProps {
  payment: Payment;
  index: number;
  onRemove: () => void;
}

const TYPE_STYLES: Record<string, string> = {
  CB: 'bg-info/20 text-info',
  ESPECES: 'bg-success/20 text-success',
  PREVENTE: 'bg-warning/20 text-warning',
};

const TYPE_LABELS: Record<string, string> = {
  CB: 'CB',
  ESPECES: 'Especes',
  PREVENTE: 'Prevente',
};

export default function PaymentBadge({ payment, onRemove }: PaymentBadgeProps) {
  const style = TYPE_STYLES[payment.type] ?? 'bg-gray-500/20 text-gray-300';
  const label = TYPE_LABELS[payment.type] ?? payment.type;

  return (
    <div className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium ${style}`}>
      <span>{label}</span>
      <span className="font-bold">{formatPrice(payment.amount)}</span>
      <button
        type="button"
        onClick={onRemove}
        className="ml-0.5 hover:opacity-70"
        aria-label="Supprimer paiement"
      >
        x
      </button>
    </div>
  );
}
